export default "__VITE_ASSET__036f6577__"